import Mutations from '../../odata/mutations';

export default { ...new Mutations('appMenuItem'), ...new Mutations('appMenuItems') };
